var path = 'C:/Projects/repos/NAERS-Web/src/components/app/reports/ingredient-risk/ingredient-risk.html';
var html = "<div layout=column> <ingredient-autocomplete ingredient-type=system label-text=\"Search by Ingredient Name\" search-display-property=SystemIngredientName on-ingredient-selected=$ctrl.selectedIngredientChanged($event)> </ingredient-autocomplete> <div layout=row layout-align=\"end center\"> <md-button class=\"md-raised md-accent\" ng-disabled=!$ctrl.selectedIngredient ng-click=$ctrl.downloadReport($ctrl.selectedIngredient) aria-label=\"Download Report\"> Download Report </md-button> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./components/app/reports/ingredient-risk/ingredient-risk.html
// module id = 713
// module chunks = 0